import { render, staticRenderFns } from "./usersAgreement.vue?vue&type=template&id=1f24825c&scoped=true"
import script from "./usersAgreement.vue?vue&type=script&lang=js"
export * from "./usersAgreement.vue?vue&type=script&lang=js"
import style0 from "./usersAgreement.vue?vue&type=style&index=0&id=1f24825c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f24825c",
  null
  
)

export default component.exports